// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function Sensibles() {

  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox minHeight="30vh"></MKBox>
      <Card
        minHeight="30vh"
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", my: 6, mx: "auto", px: 0.75 }}
            >
                <MKTypography variant="h4" gutterBottom fontWeight="bold" style={{textAlign: "center"}}>
                    Aviso sobre el Tratamiento de Datos Personales Sensibles
                </MKTypography>

                <MKTypography variant="body1" paragraph>
                    De conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, le informamos
                    que ABASTECEDORA DE REFACCIONES Y SERVICIOS ARES (ARES) podrá recabar y tratar datos personales sensibles,
                    tales como aquellos que puedan revelar aspectos como su estado de salud, origen étnico o racial, creencias religiosas,
                    ideológicas o morales, afiliación sindical, opiniones políticas o preferencia sexual, únicamente cuando sea estrictamente necesario
                    para la relación jurídica que mantenemos con usted.
                </MKTypography>

                <MKTypography variant="h5" gutterBottom fontWeight="bold">
                    Finalidad del tratamiento
                </MKTypography>

                <MKTypography variant="body1" paragraph>
                    Los datos personales sensibles que recabamos se utilizarán exclusivamente para las siguientes finalidades:
                </MKTypography>

                <ul style={{marginLeft: "30px"}}>
                    <li>
                    <MKTypography variant="body1">
                        Cumplir con obligaciones derivadas de la relación laboral, comercial o de servicios.
                    </MKTypography>
                    </li>
                    <li>
                    <MKTypography variant="body1">
                        Garantizar condiciones de salud y seguridad en el entorno de trabajo.
                    </MKTypography>
                    </li>
                    <li>
                    <MKTypography variant="body1">
                        Verificar la idoneidad del personal, clientes o proveedores en función del perfil requerido.
                    </MKTypography>
                    </li>
                </ul>

                <MKTypography variant="h5" gutterBottom fontWeight="bold">
                    Medidas de seguridad
                </MKTypography>

                <MKTypography variant="body1" paragraph>
                    ARES ha adoptado medidas de seguridad administrativas, técnicas y físicas para proteger sus datos personales sensibles,
                    evitando su daño, pérdida, alteración, destrucción o uso no autorizado.
                </MKTypography>

                <MKTypography variant="h5" gutterBottom fontWeight="bold">
                    Consentimiento expreso
                </MKTypography>

                <MKTypography variant="body1" paragraph>
                    En cumplimiento de la ley, requeriremos su consentimiento expreso y por escrito antes de recopilar o tratar cualquier
                    dato personal sensible. Usted tiene en todo momento el derecho de revocar dicho consentimiento o ejercer sus derechos
                    de acceso, rectificación, cancelación u oposición (ARCO), siguiendo el procedimiento indicado en nuestro aviso de privacidad general.
                </MKTypography>

                <MKTypography variant="h5" gutterBottom fontWeight="bold">
                    Contacto
                </MKTypography>

                <MKTypography variant="body1" paragraph>
                    Si tiene dudas o desea ejercer sus derechos respecto a sus datos personales sensibles, puede comunicarse con nosotros en:
                </MKTypography>

                <MKTypography variant="body1" paragraph>
                    - Correo electrónico: ventas@bombasares.com.mx <br />
                    - Teléfonos: 74 3741 0373 <br />
                    - Domicilio: VILLA DE TEZONTEPEC CENTRO, HIDALGO, CP 43880
                </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Sensibles;
